import * as Yup from 'yup';

export const getStepOneSchema = (t, existingTelusAccountRequired) => {
  return Yup.object().shape({
    legalBusinessName: Yup.string().required(t.businessLegalName),
    firstName: Yup.string().required(t.firstName),
    lastName: Yup.string().required(t.lastName),
    email: Yup.string()
      .email(t.emailInvalid)
      .required(t.email),
    mobileNumber: Yup.string().required(t.mobileNumber)
    .min(10,'Phone number must be 10 digits')
    .max(10, 'Phone number no more than 10 digits'),
    // bestTimeofDayToContact: Yup.string().required(t.bestTimeOfDay),
    prefferedLanguage: Yup.string().required(t.prefferedLanguage),
    province: Yup.string().required(t.province),
    existingTelusAccount: existingTelusAccountRequired
      ? Yup.string().required(t.existingTelusAccount)
      : Yup.string()
  });
};

export const getStepTwoSchema = (t, isMultiSuite) => {
    return Yup.object().shape({
        serviceAddress: Yup.string()
      .required(t.serviceAddress),
      isMultiSuite: isMultiSuite ? Yup.string()
      .required(t.isMultiSuite) : Yup.string(),
      businessType: Yup.string()
      .when('isMultiSuite', {
          is: 'Yes',
          then: Yup.string().required(t.businessType),
          otherwise: Yup.string()
      }),
      propertyRoom: Yup.string(),
      noOfEmployees: Yup.string(),
    });
  };

export const getStepThreeSchema = (t) => {
    return Yup.object().shape({
        productOfInterest: Yup.string()
      .required(t.productOfInterest),
      product: Yup.string()
      .required(t.product)
    });
  };
